import { getDynamicSetting } from '../../../utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

const PERSONAS_ENDPOINT = 'rules/v1';

export const BASE_URL = `${serverUrl}/${PERSONAS_ENDPOINT}`;
